import { __awaiter } from "tslib";
import { ConfigurationNavigationEvent } from "@plansoft-configuration-renderer/events";
import { handleConfigurationEvent } from "../events/handleConfigurationEvent";
import { PERSIST_PREFIX } from "../hooks/useSubscribeToPath";
import { addNavigation, decrementOpenRequests, incrementOpenRequests, setPath, setSelectors, } from "../reducers/actions";
import { getCurrentPath, getSelectorDefaults, getSelectors, getSessionId, getSubscribers, } from "../reducers/selectors";
import { handleCfgStateResponse } from "./handleCfgStateResponse";
import { createPathSelectors } from "./requestDefaults";
export function enterSubCfgObject(params) {
    return (dispatch_1, getState_1, _a) => __awaiter(this, [dispatch_1, getState_1, _a], void 0, function* (dispatch, getState, { cfgApi }) {
        try {
            dispatch(incrementOpenRequests());
            const rootState = getState();
            const sessionid = getSessionId(rootState);
            const currentPath = getCurrentPath(rootState);
            const currentSelectors = getSelectors(rootState);
            const subscribers = getSubscribers(rootState);
            const defaults = getSelectorDefaults(rootState);
            // keep selectors that still have subscribers
            const selectorsToKeep = currentSelectors.filter((s) => { var _a; return (_a = subscribers[s.path]) === null || _a === void 0 ? void 0 : _a.some((p) => p.startsWith(PERSIST_PREFIX)); });
            // only add selectors that do not exist yet
            const selectorsToAdd = createPathSelectors(params.path, defaults).filter((s) => !selectorsToKeep.some((p) => p.path === s.path));
            // merge old and new selectors
            const selectors = [...selectorsToKeep, ...selectorsToAdd];
            dispatch(setSelectors(selectors));
            dispatch(addNavigation({ previousPath: currentPath, nextPath: params.path }));
            const response = yield cfgApi.getConfiguration({
                id: sessionid,
                getConfigurationParams: {
                    selectors,
                },
            });
            // set response
            dispatch(handleCfgStateResponse(response));
            // we only set the path after the state is available, otherwise ConfigurationRenderer unmounts the children
            dispatch(setPath({ path: params.path, backtrack: params.isBack }));
            dispatch(handleConfigurationEvent(new ConfigurationNavigationEvent(response.id, params.path)));
        }
        finally {
            dispatch(decrementOpenRequests());
        }
    });
}
//# sourceMappingURL=enterSubCfgObject.js.map